module.exports = __webpack_public_path__ + "static/media/skelly.e2c27bf1.png";